import classes from "./ModeLabel.module.scss";

const ModeLabel = ({ mode = 'practice' }) => {
  const modeClassName = mode.toLowerCase() === 'practice' ? classes.modePractice : classes.modeAssesment;

  return (
    <span className={`${classes.modeLabel} ${modeClassName}`}>
      Mode: {mode}
    </span>
  );
};


export default ModeLabel;